export class BaseUIService {}
